export default {"src":"/_next/static/media/Bordeaux.e563499f.svg","height":173,"width":224,"blurWidth":0,"blurHeight":0};